export default __webpack_public_path__ + "static/media/default_background.0b485e7b.png";